import { FC } from "react";
import PageTemplate from "../PageTemplate";
import CreatedOrdersPage from "./CreatedOrdersPage";

const CreatedOrders: FC = () => {
    return <PageTemplate Page={CreatedOrdersPage} />;
};

export default CreatedOrders;
